import { DialogContent, DialogContentText } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import React, { useEffect, useState } from 'react';
import colors from '../../styles/settings/colors';
import fontSize from '../../styles/settings/fontSize';
import * as S from './styles';

export function AnchorSelectBox({ data }) {
  const [open, setOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setOpen(false);
    data.closeModal();
  };

  const handleConfirm = (anchor) => {
    setOpen(false);
    data.callback(anchor);
  };

  useEffect(() => {
    console.log(data)
    if (data.show) {
      setOpen(true);
    }
  }, []);

  return (
    <S.DialogModal
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      className="dialog-parent"
      widthContainer={data?.mensagemBoxLargura}
    >
      <S.DialogContainer borderColor={data?.tituloCorDeFundo} htmlText={data?.htmlText}>
        <div style={{ overflow: 'auto', maxHeight: '85vh' }}>
          {data.anchors.redes || data.anchors.redeCapittale || data.anchors.plataformas ? (
            <>
              {data.anchors.redeCapittale.ancoraId > 0 && (
                <>
                  <S.Title>Rede Capittale</S.Title>
                  <DialogContent>
                    <DialogContentText>
                      <S.AnchorOption>
                        <div
                          className={`pointer capittale`}
                          onClick={() => {handleConfirm(data.anchors.redeCapittale)}}
                        >
                          {data.anchors.redeCapittale.logotipoLink ? (
                              <img
                              style={{ objectFit: 'contain', background: 'white' }}
                              src={data.anchors.redeCapittale.logotipoLink}
                              alt={`Logo da rede ${data.anchors.redeCapittale.nomeFantasia ? 
                                data.anchors.redeCapittale.nomeFantasia : data.anchors.redeCapittale.plataforma}`}
                            />
                            ) : (
                              <div style={{cursor: 'pointer'}}>
                              {data.anchors.redeCapittale.nomeFantasia ?
                              data.anchors.redeCapittale.nomeFantasia : data.anchors.redeCapittale.plataforma}
                              </div>
                            )}
                        </div>
                      </S.AnchorOption>
                    </DialogContentText>
                  </DialogContent>
                </>
              )}
              {data.anchors.plataformas.length > 0 && (
                <>
                  <S.Title>Plataformas Disponíveis</S.Title>
                  <DialogContent>
                    <DialogContentText>
                      <S.AnchorOption>
                        {data.anchors.plataformas.map((plat) => (
                          <div
                            key={plat?.plataformaId}
                            className={`pointer`}
                            onClick={() => {handleConfirm(plat)}}
                          >
                            {plat?.logotipoLink ? (
                              <img
                              style={{ objectFit: 'contain', background: 'white' }}
                              src={plat.logotipoLink}
                              alt={`Logo da rede ${plat.nomeFantasia ? 
                                plat.nomeFantasia : plat.plataforma}`}
                            />
                            ) : (
                              <div style={{cursor: 'pointer'}}>
                              {plat.nomeFantasia ? plat.nomeFantasia : plat.plataforma}
                              </div>
                            )}
                          </div>
                        ))}
                      </S.AnchorOption>
                    </DialogContentText>
                  </DialogContent>
                </>
              )}
              {data.anchors.redes.length > 0 && (
                <>
                  <S.Title>Redes Disponíveis</S.Title>
                  <DialogContent>
                    <DialogContentText>
                      <S.AnchorOption>
                        {data.anchors.redes.map((anchor) => (
                          <div
                            key={anchor?.ancoraId}
                            className={`pointer ${anchor?.ancoraId === 999999 ? 'capittale' : ''}`}
                            onClick={() => {handleConfirm(anchor)}}
                          >
                            {anchor?.logotipoLink ? (
                              <img
                              style={{ objectFit: 'contain', background: 'white' }}
                              src={anchor.logotipoLink}
                              alt={`Logo da rede ${anchor.nomeFantasia ? 
                                anchor.nomeFantasia : anchor.plataforma}`}
                            />
                            ) : (
                              <div style={{cursor: 'pointer'}}>
                              {anchor.nomeFantasia ? anchor.nomeFantasia : anchor.plataforma}
                              </div>
                            )}
                          </div>
                        ))}
                      </S.AnchorOption>
                    </DialogContentText>
                  </DialogContent>
                </>
              )}
            </>
          ) : (
            <>
              <S.Title>Redes Disponíveis</S.Title>
              <DialogContent>
                <DialogContentText>
                  <S.AnchorOption>
                    {data.anchors.map((anchor) => (
                      <div
                        key={anchor?.ancoraId}
                        className={`pointer ${anchor?.ancoraId === 999999 ? 'capittale' : ''}`}
                        onClick={() => {handleConfirm(anchor)}}
                      >
                        {anchor?.logotipoLink ? (
                          <img
                          style={{ objectFit: 'contain', background: 'white' }}
                          src={anchor.logotipoLink}
                          alt={`Logo da rede ${anchor.nomeFantasia ? 
                            anchor.nomeFantasia : anchor.plataforma}`}
                        />
                        ) : (
                          <div style={{cursor: 'pointer'}}>
                          {anchor.nomeFantasia ? anchor.nomeFantasia : anchor.plataforma}
                          </div>
                        )}
                      </div>
                    ))}
                  </S.AnchorOption>
                </DialogContentText>
              </DialogContent>
            </>
          )}
        </div>
        <S.DialogActionsMessage>
          <Button
            onClick={handleClose}
            style={{ backgroundColor: 'rgb(35, 45, 100)', fontWeight: '400', color: "#fff" }}
              >
            Fechar
          </Button>
        </S.DialogActionsMessage>
      </S.DialogContainer>
    </S.DialogModal>
  );
}
